import React from 'react';
import type { InventoryItemDetailsTab } from '../../../hooks/inventory-hooks/useInventoryItemDetailsState';

interface InventoryItemTabsProps {
  itemType: string;
  activeTab: InventoryItemDetailsTab;
  showSamplesTab: boolean;
  onTabChange: (tab: InventoryItemDetailsTab) => void;
}

export const InventoryItemTabs: React.FC<InventoryItemTabsProps> = ({
  itemType,
  activeTab,
  showSamplesTab,
  onTabChange,
}) => {
  return (
    <div className="border-b border-gray-200 mb-4" data-test-id="inventory-item-tabs">
      <nav className="-mb-px flex space-x-8">
        {itemType !== 'finished_good' && (
          <button
            data-test-id="inventory-item-tab-lots"
            onClick={() => onTabChange('lots')}
            className={`${
              activeTab === 'lots'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            Active Lots
          </button>
        )}

        {itemType === 'finished_good' && (
          <button
            data-test-id="inventory-item-tab-ingredients"
            onClick={() => onTabChange('ingredients')}
            className={`${
              activeTab === 'ingredients'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            Ingredients
          </button>
        )}

        {itemType !== 'finished_good' && showSamplesTab && (
          <button
            data-test-id="inventory-item-tab-samples"
            onClick={() => onTabChange('sample')}
            className={`${
              activeTab === 'sample'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            Samples
          </button>
        )}
      </nav>
    </div>
  );
};
